"use client"

import { useState, useEffect } from "react"

export const getStorageKey = () => {
  if (typeof window === 'undefined') return '';
  const path = window.location.pathname;
  const cleanPath = path.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  return `filters_${cleanPath || 'home'}`;
};

export const usePCFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState(() => {
    const key = getStorageKey();
    if (typeof window === 'undefined' || !key) return initialFilters;
    
    try {
      const saved = localStorage.getItem(key);
      if (!saved) return initialFilters;
      
      const savedFilters = JSON.parse(saved);
      const pcFilters = {
        selectedCoin: savedFilters.selectedCoin || initialFilters.selectedCoin,
        selectedCompany: savedFilters.selectedCompany || initialFilters.selectedCompany,
        mode: savedFilters.mode || initialFilters.mode,
        endDate: savedFilters.endDate || initialFilters.endDate,
        period: savedFilters.period || initialFilters.period,
        selectedProject: savedFilters.selectedProject || initialFilters.selectedProject,
        billsByPCLevel: savedFilters.billsByPCLevel || initialFilters.billsByPCLevel,
        spendLevel: savedFilters.spendLevel || initialFilters.spendLevel,
        selectedPCItem: savedFilters.selectedPCItem || initialFilters.selectedPCItem,
        selectedPCItemPeriod: savedFilters.selectedPCItemPeriod || initialFilters.selectedPCItemPeriod,
        selectedPCSpenItem: savedFilters.selectedPCSpenItem || initialFilters.selectedPCSpenItem,
        chartType: savedFilters.chartType || initialFilters.chartType,
      };
      
      return pcFilters;
    } catch (error) {
      console.error('Error al cargar filtros PC:', error);
      return initialFilters;
    }
  });

  useEffect(() => {
    const key = getStorageKey();
    if (!key || typeof window === 'undefined') return;
    
    try {
      localStorage.setItem(key, JSON.stringify(filters));
    } catch (error) {
      console.error('Error al guardar filtros PC:', error);
    }
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  return { filters, updateFilter, setFilters };
};

export const useGeneralFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState(() => {
    const key = getStorageKey();
    if (typeof window === 'undefined' || !key) return initialFilters;
    
    try {
      const saved = localStorage.getItem(key);
      if (!saved) return initialFilters;
      
      const savedFilters = JSON.parse(saved);
      const generalFilters = {
        selectedCoin: savedFilters.selectedCoin || initialFilters.selectedCoin,
        selectedCompany: savedFilters.selectedCompany || initialFilters.selectedCompany,
        mode: savedFilters.mode || initialFilters.mode,
        startDate: savedFilters.startDate || initialFilters.startDate,
        endDate: savedFilters.endDate || initialFilters.endDate,
        period: savedFilters.period || initialFilters.period,
        selectedProject: savedFilters.selectedProject || initialFilters.selectedProject,
        billsByFamilyLevel: savedFilters.billsByFamilyLevel || initialFilters.billsByFamilyLevel,
      };
      
      return generalFilters;
    } catch (error) {
      console.error('Error al cargar filtros generales:', error);
      return initialFilters;
    }
  });

  useEffect(() => {
    const key = getStorageKey();
    if (!key || typeof window === 'undefined') return;
    
    try {
      localStorage.setItem(key, JSON.stringify(filters));
    } catch (error) {
      console.error('Error al guardar filtros generales:', error);
    }
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  return { filters, updateFilter, setFilters };
};